import { AxiosResponse } from "axios";
import http from "../common/services/httpService";

import {
  VehicleContractSearchResultDto,
  VehicleContactWaitingSearchResultDto,
  VehicleContractInputDto,
  VehicleContractPreviewDto,
} from "../interfaces/VehicleContract";

const apiEndpoint = "/vehicleContract";

const getWaitingVehicleContractsAsync = async (
  query: string
): Promise<AxiosResponse<Array<VehicleContactWaitingSearchResultDto>>> => {
  return await http.get<Array<VehicleContactWaitingSearchResultDto>>(`${apiEndpoint}/waiting?${query}`);
};

const getWaitingVehicleContractsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/waiting/count?${query}`);
};

const getVehicleContractsAsync = async (
  query: string
): Promise<AxiosResponse<Array<VehicleContractSearchResultDto>>> => {
  return await http.get<Array<VehicleContractSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getVehicleContractsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getVehicleContractAsync = async (id: number): Promise<AxiosResponse<VehicleContractPreviewDto>> => {
  return await http.get<VehicleContractPreviewDto>(`${apiEndpoint}/${id}`);
};

const updateVehicleContractAsync = async (
  model: VehicleContractInputDto
): Promise<AxiosResponse<VehicleContractInputDto>> => {
  return await http.put<VehicleContractInputDto>(`${apiEndpoint}/${model.vehicleContractId}`, model);
};

const rejectVehicleContractAsync = async (id: number): Promise<AxiosResponse> => {
  return await http.put(`${apiEndpoint}/reject/${id}`);
};

const annulleVehicleContractAsync = async (id: number): Promise<AxiosResponse> => {
  return await http.put(`${apiEndpoint}/annulle/${id}`);
};

export default {
  getWaitingVehicleContractsAsync,
  getWaitingVehicleContractsCountAsync,
  getVehicleContractsAsync,
  getVehicleContractsCountAsync,
  getVehicleContractAsync,
  updateVehicleContractAsync,
  rejectVehicleContractAsync,
  annulleVehicleContractAsync,
};
